import Tooltip from 'rc-tooltip'
import React from 'react'
import { Link } from 'react-router-dom'

import './Input.css'

export function Input(props) {

    let inputWrapperClassName = ['input-wrapper'];
    if(props.error) inputWrapperClassName.push('error');
    if(props.inputclassname) inputWrapperClassName.push(props.inputclassname);

    inputWrapperClassName = inputWrapperClassName.join(' ');


	return (
		<div className={`field-group${props?.fluid ? ' fluid' : ''}`}>
			{props.label && <label>{props.label} {props.required ? '*' : ''}</label>}
            { props.onlyOnPaidPlan && Object.keys(props.onlyOnPaidPlan).length > 0 &&  
                <Tooltip 
                    placement="top" 
                    trigger={['hover']} 
                    overlay={<span>{props.onlyOnPaidPlan?.message}</span>}
                    >
                    <Link to={props.onlyOnPaidPlan?.link}><span className='pro-feature-tag'>{props.onlyOnPaidPlan?.available_plan} Feature</span></Link>
                </Tooltip>
                }
            <div className={inputWrapperClassName}>
                { props.prefix && <div className='input-prefix'>{props.prefix}</div>}
			    <input 
                    className={`${props.className ?? ''} ${props.error ? 'error' : ''}`} 
                    disabled={props.onlyOnPaidPlan && Object.keys(props.onlyOnPaidPlan).length > 0  ? true : false } {...props}/>
                { props.suffix && <div className='input-suffix'>{props.suffix}</div>}
            </div>
            { props.error && <div className='field--error'>{props.error}</div>}
            { props.note && <div className='field--note'>{props.note}</div>}
		</div>
	)
}
